"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _Box = _interopRequireDefault(require("../../Box"));
var _Calendar = _interopRequireDefault(require("./Calendar"));
var _Header = _interopRequireDefault(require("./Header"));
var _MonthSelection = _interopRequireDefault(require("./MonthSelection"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["view", "current", "minDate", "maxDate", "disablePast", "disableFuture", "isDateSelected", "isDateDisabled", "focusedDate", "onDateFocus", "onDateHover", "onDateSelect", "onCurrentChange", "isDateHighlighted", "isDateHighlightStart", "isDateHighlightEnd", "showDaysOutsideCurrentMonth", "renderDay", "className", "test", "withTodayButton"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ViewSwitcher = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'date' : _ref$view,
    current = _ref.current,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    disablePast = _ref.disablePast,
    disableFuture = _ref.disableFuture,
    isDateSelected = _ref.isDateSelected,
    isDateDisabled = _ref.isDateDisabled,
    focusedDate = _ref.focusedDate,
    onDateFocus = _ref.onDateFocus,
    onDateHover = _ref.onDateHover,
    onDateSelect = _ref.onDateSelect,
    onCurrentChange = _ref.onCurrentChange,
    isDateHighlighted = _ref.isDateHighlighted,
    isDateHighlightStart = _ref.isDateHighlightStart,
    isDateHighlightEnd = _ref.isDateHighlightEnd,
    showDaysOutsideCurrentMonth = _ref.showDaysOutsideCurrentMonth,
    renderDay = _ref.renderDay,
    className = _ref.className,
    test = _ref.test,
    withTodayButton = _ref.withTodayButton,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box["default"], _objectSpread(_objectSpread({
    "data-cy": 'pickerCalendar',
    minWidth: view === 'date' ? 304 : 212,
    mb: 1
  }, props), {}, {
    ref: ref,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header["default"], {
      view: view,
      current: current,
      minDate: minDate,
      maxDate: maxDate,
      disablePast: disablePast,
      disableFuture: disableFuture,
      onCurrentChange: onCurrentChange,
      test: test
    }), view === 'month' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MonthSelection["default"], {
      current: current,
      focusedMonth: focusedDate,
      isMonthSelected: isDateSelected,
      isMonthDisabled: isDateDisabled,
      isMonthHighlighted: isDateHighlighted,
      isMonthHighlightStart: isDateHighlightStart,
      isMonthHighlightEnd: isDateHighlightEnd,
      onMonthSelect: onDateSelect,
      onMonthFocus: onDateFocus,
      onMonthHover: onDateHover
    }, current.toString()), view === 'date' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar["default"], {
      current: current,
      focusedDate: focusedDate,
      isDateSelected: isDateSelected,
      isDateDisabled: isDateDisabled,
      isDateHighlighted: isDateHighlighted,
      isDateHighlightStart: isDateHighlightStart,
      isDateHighlightEnd: isDateHighlightEnd,
      onDateFocus: onDateFocus,
      onDateHover: onDateHover,
      onDateSelect: onDateSelect,
      showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
      renderDay: renderDay,
      withTodayButton: withTodayButton
    }, current.toString())]
  }));
});
var _default = exports["default"] = ViewSwitcher;